import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import useCanManageUsers from "shared/User/access/useCanManageUsers";

import { ANALYTICS } from "../constants";
import { CellComponentProps } from "../types";
import { showSlackIntegration } from "../SlackIntegrationDrawer";
import { showSlackIntegrationDeleteConfirmation } from "./SlackIntegrationDeleteConfirmation";

type UserIntegrationsListItemActionsDropdownCellProps = CellComponentProps;

const UserIntegrationsListItemActionsDropdownCell = ({
  integration,
  user,
}: UserIntegrationsListItemActionsDropdownCellProps) => {
  const canManageUsers = useCanManageUsers();

  return (
    <DropdownMenuEllipsis tooltip="Integration actions">
      <CopyFieldDropdownMenuItem title="Copy ID" value={integration.id} />

      {canManageUsers && (
        <DropdownMenuItem
          {...ANALYTICS}
          analyticsTitle="Edit clicked"
          onAction={() => showSlackIntegration({ slackMemberID: integration.id, user })}
        >
          Edit
        </DropdownMenuItem>
      )}
      {canManageUsers && (
        <DropdownMenuItem
          {...ANALYTICS}
          analyticsTitle="Delete clicked"
          onAction={() => showSlackIntegrationDeleteConfirmation({ user })}
          danger
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default UserIntegrationsListItemActionsDropdownCell;
